import { useCallback } from "react";
import { useEditor, EditorContent, Editor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import TextAlign from "@tiptap/extension-text-align";
import TipTapToolbar from "./TipTapToolBar";
import { ITaskManagement } from "../../models/taskManagement.model";
import { styled } from "styled-components";

const CleanEditor = styled(EditorContent)`
  border: none;
  outline: none;

  .ProseMirror {
    border: none;
    outline: none;
    box-shadow: none;
  }
`;
interface TiptapEditorProps {
  form: ITaskManagement;
  setForm: React.Dispatch<React.SetStateAction<ITaskManagement>>;
}

const TiptapEditor: React.FC<TiptapEditorProps> = ({ form, setForm }) => {
  const handleChange = useCallback(
    (content: string) => {
      setForm({ ...form, description: content });
    },
    [form, setForm]
  );

  const editor = useEditor(
    {
      extensions: [
        StarterKit,
        TextAlign.configure({
          types: ["heading", "paragraph"],
          alignments: ["left", "center", "right", "justify"],
        }),
      ],
      content: form.description,
      onUpdate: ({ editor }: { editor: Editor }) => {
        handleChange(editor.getHTML());
      },
    },
    []
  );

  if (!editor) return null;

  return (
    <div className="editor-container border border-gray-300 rounded-lg">
      <TipTapToolbar editor={editor} />
      <div className="min-h-20 p-2">
        <CleanEditor
          className="tiptap-editor focus:outline-none focus:ring-0 border-0"
          editor={editor}
        />
      </div>
    </div>
  );
};

export default TiptapEditor;
